import { TW_AppBlogArticle, TW_AppBlogArticleImage, TW_AppBlogParagraphMargin } from '@utils/twClasses';
import makeConnexionModule from '@img/Make_Connexion_Module.png';
import makeRetrieveModule from '@img/Make_Retrieve_Module.png';
import makeUpdateModule from '@img/Make_Update_Module.png';
import makeCreateModule from '@img/Make_Create_Module.png';

export default function MakeAutomation() {

    return (
        <div className={TW_AppBlogArticle}>
            <h1 className="mb-6 text-3xl font-semibold text-black">
                Automation with Make
            </h1>
            <p className={TW_AppBlogParagraphMargin}>We've all been there: form responses received by email that need to be processed manually one by one to transfer the info into Excel or elsewhere, a CRM on one side and a billing system on the other that don't communicate with each other, resulting in both systems needing to be updated for every small change, and so on. So many repetitive and tedious tasks that can be avoided thanks to automation.</p>
            <p className={TW_AppBlogParagraphMargin}>Compozz was designed and created to make your life easier, so it was out of the question to skip such a crucial feature. And since we also know you may not have the resources to create your own connectors, we chose a no-code solution that lets you connect multiple systems together: <a href='https://www.make.com/en' className="text-compozz-purple hover:underline" target="_blank">Make</a>.</p>
            <p className={TW_AppBlogParagraphMargin}>As of today, you have access to 4 Compozz modules:</p>
            <ul className="list-disc list-inside">
                <li>
                    <span className="font-semibold">Connect to Compozz</span>
                    <p className="mt-5">To use the other modules, you must use this connection module to Compozz. Enter your Compozz username and password.</p>
                    <img
                        src={makeConnexionModule}
                        alt="Module de connexion danConnection module in Make"
                        width={644}
                        height={513}
                        className={TW_AppBlogArticleImage}
                    />
                </li>
                <li>
                    <span className="font-semibold">Retrieve Records</span>
                    <p className="mt-5 mb-5">This module allows you to retrieve data stored in Compozz.</p>
                    <p className={TW_AppBlogParagraphMargin}>In the “Access token” field, enter the token returned by the “Connect to Compozz” module.</p>
                    <p className={TW_AppBlogParagraphMargin}>Then enter the name of the workspace from which you want to retrieve data, followed by the object name and finally the fields of the object you want to retrieve.</p>
                    <p className={TW_AppBlogParagraphMargin}>The field names, object name, and workspace name must exactly match those in Compozz.</p>
                    <p className={TW_AppBlogParagraphMargin}>You can also refine your search using filters. To do this, specify the field name to apply the filter on and the value to search for.</p>
                    <p>In the example below, we want to check whether we have a customer named Impulse in the Clients object within the Plugin Make workspace.</p>
                    <img
                        src={makeRetrieveModule}
                        alt="Record retrieval module in Make"
                        width={690}
                        height={800}
                        className={TW_AppBlogArticleImage}
                    />
                </li>
                <li>
                    <span className="font-semibold">Update Record</span>
                    <p className="mt-5 mb-5">Now that you’ve retrieved a record, you can use the “Update Record” module to update it.</p>
                    <p className={TW_AppBlogParagraphMargin}>Fill in “Access token”, “Workspace Name”, and “Object Name” the same way as before.</p>
                    <p className={TW_AppBlogParagraphMargin}>The “Record Key” field corresponds to the ID of the record you want to update in Compozz. It is returned by the “Retrieve Records” module.</p>
                    <p>In “Fields”, enter the name of the field to be updated in “Field Name” and the new value in “Field Value”. Repeat this step for each field you want to update.</p>
                    <img
                        src={makeUpdateModule}
                        alt="Record update module in Make"
                        width={777}
                        height={908}
                        className={TW_AppBlogArticleImage}
                    />
                </li>
                <li>
                    <span className="font-semibold">Create Record</span>
                    <p className="mt-5">If you want to create a new record in Compozz, use the “Create Record” module. It works the same way as the “Update Record” module, except you don’t need to provide an ID since it doesn’t exist yet.</p>
                    <img
                        src={makeCreateModule}
                        alt="Record creation module in Make"
                        width={777}
                        height={908}
                        className={TW_AppBlogArticleImage}
                    />
                </li>
            </ul>
            <p className={TW_AppBlogParagraphMargin}>You now have everything you need to connect Compozz to your other systems and save time while boosting efficiency. If you encounter any difficulties, don't hesitate to <a href="/freeTrial" className="text-compozz-darker-purple hover:underline">contact us</a>!</p>
        </div>

    )
}